import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import TripList from '@/views/TripList.vue'
import ContactsPage from '@/views/ContactsPage.vue'
import ZavbusServiceListPage from '@/views/ZavbusServiceList/ZavbusServiceListPage.vue'
import ZavbusServicePage from '@/views/ZavbusService/ZavbusServicePage.vue'
import TripDetailsView from '@/views/TripDetails/TripDetailsView.vue'
import TripRidersPage from '@/views/TripRiders/TripRidersPage.vue'
import TripAllDetailsPage from '@/views/TripAllDetails/TripAllDetailsPage.vue'
import TripPageLayout from "@/views/TripPageLayout.vue";
import RiderAccountLayout from "@/views/RiderAccount/RiderAccountLayout.vue";
import AccountBonusesPage from "@/views/RiderAccount/AccountBonuses/AccountBonusesPage.vue";
import AccountSettingsPage from "@/views/RiderAccount/AccountSettings/AccountSettingsPage.vue";
import AccountTripHistoryPage from "@/views/RiderAccount/AccountTripHistory/AccountTripHistoryPage.vue";
import RiderProfilePage from "@/views/RiderProfile/RiderProfilePage.vue";
import PolicyLayout from "@/views/Policies/PolicyLayout.vue";
import CookiePolicyPage from "@/views/Policies/CookiePolicy/CookiePolicyPage.vue";
import PrivacyPolicyPage from "@/views/Policies/PrivacyPolicy/PrivacyPolicyPage.vue";
import TermsOfUsePage from "@/views/Policies/TermsOfUse/TermsOfUsePage.vue";
import PublicOfferPage from "@/views/Policies/PublicOffer/PublicOfferPage.vue";
import AdvertisingPolicyPage from "@/views/Policies/AdvertisingPolicy/AdvertisingPolicyPage.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'firstPage',
        meta: {layout: 'ContentLayout'},
        component: TripList
    },
    {
        path: '/profile/:id',
        name: 'profile',
        meta: {layout: 'ContentLayout'},
        component: RiderProfilePage
    },
    {
        path: '/trips',
        name: 'tripList',
        meta: {layout: 'ContentLayout'},
        component: TripList
    },
    {
        path: '/contacts',
        name: 'contacts',
        meta: {layout: 'ContentLayout'},
        component: ContactsPage
    },
    {
        path: '/services',
        name: 'services',
        meta: {layout: 'ContentLayout'},
        component: ZavbusServiceListPage
    },
    {
        path: '/service/:code',
        name: 'service',
        meta: {layout: 'ContentLayout'},
        component: ZavbusServicePage
    },
    {
        path: '/tripdetails/:id',
        name: 'tripDetails',
        meta: {layout: 'ContentLayout'},
        component: TripDetailsView
    },
    {
        path: '/trip/:id',
        name: 'trip',
        meta: {layout: 'ContentLayout'},
        component: TripPageLayout,
        children: [
            {
                path: 'riders',
                name: 'riders',
                component: TripRidersPage
            },
            {
                path: 'info',
                name: 'info',
                component: TripAllDetailsPage
            }
        ]
    },
    {
        path: '/account',
        name: 'account',
        meta: {layout: 'ContentLayout'},
        component: RiderAccountLayout,
        children: [
            {
                path: 'tripHistory',
                name: 'tripHistory',
                component: AccountTripHistoryPage
            },
            {
                path: 'bonuses',
                name: 'bonuses',
                component: AccountBonusesPage
            },
            {
                path: 'settings',
                name: 'settings',
                component: AccountSettingsPage
            }
        ]
    },
    {
        path: '/policies',
        name: 'policies',
        meta: {layout: 'ContentLayout'},
        component: PolicyLayout,
        children: [
            {
                path: 'cookiePolicy',
                name: 'cookiePolicy',
                component: CookiePolicyPage
            },
            {
                path: 'termsOfUse',
                name: 'termsOfUse',
                component: TermsOfUsePage
            },
            {
                path: 'privacyPolicy',
                name: 'privacyPolicy',
                component: PrivacyPolicyPage
            },
            {
                path: 'publicOffer',
                name: 'publicOffer',
                component: PublicOfferPage
            },
            {
                path: 'advertisingPolicy',
                name: 'advertisingPolicy',
                component: AdvertisingPolicyPage
            },
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
